<template>
  <!-- 頭部整體盒子 -->
  <header id="header" class="container-fuild">
    <!-- 頭部頂部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span> {{ companyInfoItem.telephone || '+ 852 3956 3953' }}
          <!-- <span class="glyphicon glyphicon-envelope"></span>info@xinlinghai.com.hk -->
          <span class="glyphicon glyphicon-time"></span>{{ $t('header.telephone') }}
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>{{ $t('header.slogan') }}
          <span class="glyphicon glyphicon-hand-left"></span>
          <span class="lang-switch" @click="switchLang" style="cursor: pointer; margin-left: 15px; padding: 2px 8px; background: rgba(255,255,255,0.2); border-radius: 12px;">
            <span class="glyphicon glyphicon-globe"></span> {{ $i18n.locale === 'zh-TW' ? 'English' : '繁體中文' }}
          </span>
        </div>
      </div>
    </div>

    <!-- 電腦導航 -->
    <nav class="header-nav container hidden-xs">
      <!-- 導航logo -->
      <div class="header-nav-logo">

        <img src="@/assets/img/logo_black.png" alt="新領海機械行有限公司標誌">
        <span class="company-name">{{ companyInfoItem.comname || $t('header.companyName') }} </span>

      </div>

      <!-- 導航內容 -->
      <ul class="header-nav-wrapper" style="margin-top: 0px;">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </nav>

    <!-- 手機導航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
        <span class="company-name">{{ companyInfoItem.comname || $t('header.companyName') }} </span>
      </div>
      <!-- 導航欄 -->
      <div class="header-nav-m-menu text-center">
        <div class="menu-title">{{menuName}}</div>
        <div
          class="header-nav-m-lang-wrapper"
          @click="switchLang"
          style="position: absolute; top: 50%; left: 20px; transform: translateY(-50%); color: #fff; cursor: pointer; padding: 4px 8px; border: 1px solid rgba(255,255,255,0.3); border-radius: 4px;"
        >
          {{ $i18n.locale === 'zh-TW' ? 'EN' : '繁' }}
        </div>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 導航內容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuClass: "glyphicon glyphicon-menu-down",
      companyInfoItem:{},
    };
  },
  computed: {
    navList() {
      return [
        {
          name: this.$t('header.nav.home'),
          path: "/",
          children: []
        },
        {
          name: this.$t('header.nav.service'),
          path: "/service",
          children: []
        },
        {
          name: this.$t('header.nav.news'),
          path: "/newsinformation",
          children: []
        },
        {
          name: this.$t('header.nav.about'),
          path: "/companyintroduction",
          children: []
        },
        {
          name: this.$t('header.nav.job'),
          path: "/jobchance",
          children: []
        },
        {
          name: this.$t('header.nav.contact'),
          path: "/contactus",
          children: []
        }
      ]
    },
    menuName() {
      if (this.navList && this.navList[this.navIndex]) {
        return this.navList[this.navIndex].name;
      }
      return this.$t('header.nav.home');
    }
  },
  mounted() {

    // 首先尝试从 localStorage 获取数据
    const cachedData = localStorage.getItem('companyInfoItem');
    if (cachedData) {
      this.companyInfoItem = JSON.parse(cachedData);
      console.log("从缓存获取公司信息数据 = " + JSON.stringify(this.companyInfoItem));

    }

  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    switchLang() {
      const currentLang = this.$i18n.locale;
      const newLang = currentLang === 'zh-TW' ? 'en' : 'zh-TW';
      this.$i18n.locale = newLang;
      localStorage.setItem('lang', newLang);
    }
  }
};
</script>

<style scoped>
/* 顶部 */
#header {
  background: #ffffff; /* Changed to pure white for cleaner look */
  transition: all ease 0.4s;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08); /* Increased shadow for depth */
  position: relative;
  width: 100%;
  z-index: 1000; /* Ensure header is on top */
}

/* 添加底部淡雅轮廓效果 */
#header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg,
    var(--primary-color) 0%,
    var(--primary-dark) 50%,
    var(--primary-color) 100%); /* Simplified to solid primary color gradient */
  opacity: 0.8;
}

/* Removed complex before/after pseudo-elements that clutter the design */
#header::before {
  display: none;
}

#header .header-top {
  height: 40px; /* Slightly shorter */
  color: #fff;
  font-size: 13px;
  line-height: 40px;
  background: var(--primary-dark); /* Use variable */
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 添加顶部图标悬停效果 */
#header .header-top span:hover {
  color: var(--accent-color); /* Use variable */
}

/* 导航栏 */
#header .header-nav {
  height: 90px; /* Slightly taller */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  background: #fff;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: auto;
  height: 100%;
  float: left;
  position: relative;
  margin-right: 50px;
  display: flex;
  align-items: center;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: auto;
  height: 50px; /* Fixed height */
  margin-right: 15px;
  transition: all 0.3s ease;
}

#header .header-nav .header-nav-logo img:hover {
  transform: scale(1.05);
}

/* 公司名称样式 */
#header .header-nav .header-nav-logo .company-name {
  justify-content: center;
  font-size: 22px;
  font-weight: 700; /* Bolder */
  color: var(--primary-dark);
  white-space: nowrap;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

/* 导航栏 导航容器 */
#header .header-nav .header-nav-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  margin: 0;
  height: 100%;
  flex: 1;
  margin-top: 0 !important;
  position: relative;
}

/* Remove grid background effects for cleaner look */
#header .header-nav .header-nav-wrapper::before,
#header .header-nav .header-nav-wrapper::after {
  display: none;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  list-style: none;
  margin: 0;
  padding: 0 15px; /* Adjusted padding */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: var(--text-color);
  font-size: 16px;
  text-decoration: none;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 5px;
  position: relative;
  font-weight: 500;
  transition: all 0.3s ease;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i.underline {
  display: block;
  position: absolute;
  bottom: 25px; /* Adjusted position */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
  border-radius: 2px;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: var(--primary-color);
}

#header .header-nav .header-nav-wrapper > li > a:hover > i.underline {
  width: 100%;
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: var(--primary-color);
  font-weight: 600;
}

#header .header-nav .header-nav-wrapper > li.active > a > i.underline {
  width: 100%;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #fff;
  margin: 0;
  padding: 0;
  z-index: 999;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 12px 15px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  color: #555;
  text-decoration: none;
  display: block;
  transition: all 0.3s ease;
}

#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #3370FF;
  transform: translateX(5px);
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover > dl {
  display: block;
  animation: fadeIn 0.3s ease;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  background-color: #f5f8ff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 70px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
    max-width: 100%;
    margin: 0 auto;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 46px;
    height: 40px;
    margin-left: 0;
    margin-right: 10px;
  }

  /* 手机导航公司名称样式 */
  #header .header-nav-m .header-nav-m-logo .company-name {
    font-size: 18px;
    font-weight: bold;
    color: #1e3d7b;
    white-space: nowrap;
    text-align: center;
    margin-right: 0;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 56px;
    font-size: 18px;
    line-height: 56px;
    background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }

  /* 菜单标题 */
  #header .header-nav-m .header-nav-m-menu .menu-title {
    flex: 1;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    max-width: calc(100% - 100px);
    font-weight: 500;
    letter-spacing: 1px;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 50px;
    height: 46px;
    color: #fff;
    z-index: 999999;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  #header .header-nav-m .header-nav-m-menu-wrapper:hover {
    transform: translateY(-50%) scale(1.1);
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 56px;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999999;
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    overflow: hidden;
    border-radius: 0 0 12px 12px;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    text-align: center;
    transition: background 0.3s ease;
  }

  #header .header-nav-m .header-nav-m-wrapper > li:hover {
    background: var(--bg-light);
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: var(--text-color);
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    position: relative;
    display: inline-block;
    width: 100%;
    text-align: center;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  /* 导航栏 每个导航下面的 a 链接的下划线 */
  #header .header-nav-m .header-nav-m-wrapper > li > a > i.underline {
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 2px;
    background-color: var(--primary-color);
    transition: width 0.3s ease;
  }

  /* 导航栏 选中状态 */
  #header .header-nav-m .header-nav-m-wrapper > li.active {
    background: var(--bg-light);
  }

  #header .header-nav-m .header-nav-m-wrapper > li.active > a {
    color: var(--primary-color);
    font-weight: 600;
  }

  #header .header-nav-m .header-nav-m-wrapper > li.active > a > i.underline {
    width: 60px;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
    margin-left: 4px;
    transition: all 0.3s ease;
  }

  #header .header-nav .header-nav-wrapper > li:hover > a > span {
    transform: rotate(180deg);
  }
}

@media screen and (max-width: 480px) {
  #header .header-top {
    font-size: 12px;
  }

  #header .header-nav-m .header-nav-m-logo {
    height: 60px;
  }

  #header .header-nav-m .header-nav-m-logo img {
    width: 40px;
    height: 35px;
  }

  #header .header-nav-m .header-nav-m-logo .company-name {
    font-size: 16px;
    color: var(--primary-dark);
  }

  #header .header-nav-m .header-nav-m-menu {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }

  #header .header-nav-m .header-nav-m-wrapper {
    top: 50px;
  }

  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 48px;
    line-height: 48px;
  }

  #header .header-nav-m .header-nav-m-wrapper > li > a {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue